import React, {useEffect} from "react";
// nodejs library that concatenates classes
import axios from "axios";
import classNames from "classnames";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useLocation } from "react-router";
// @material-ui/core components
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import SweetAlert from "react-bootstrap-sweetalert";

import { headApi, credentials } from "utils/headApi";

import contactStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/contactStyle.js";
import style from "assets/jss/material-kit-pro-react/components/buttonStyle.js";

const useStyles = makeStyles(contactStyle);
const useStyleAlert = makeStyles(style);

export default function SectionContact() {
  const [firstName, setFirstName] = React.useState("");
  const [firstNameErr, setFirstNameErr] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [mobileErr, setMobileErr] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [emailErr, setEmailErr] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [messageErr, setMessageErr] = React.useState("");
  const [userDel, setUserDel] = React.useState({});

  const [submitted, setSubmitted] = React.useState(false);
  const [submitteds, setSubmitteds] = React.useState(false);
  const [alertMsg, alertMsgOps] = React.useState("");
  const [alertType, alertTypeOps] = React.useState("");

  const [specialitySelect, setSpecialitySelect] = React.useState("1");

  const { search } = useLocation();
  const a = new URLSearchParams(search).get("a");
  const p = new URLSearchParams(search).get("p");
  const category = new URLSearchParams(search).get("category");
  const state = new URLSearchParams(search).get("state");
  const catSize = new URLSearchParams(search).get("catSize");
  const country = new URLSearchParams(search).get("country");

  const handleSpeciality = (event) => {
    setSpecialitySelect(event.target.value);
  };

  const classes = useStyles();
  const classeAlert = useStyleAlert();

  useEffect(() => {
    axios
      .get(headApi + `/admin/byId/${a}`, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
      .then((res) => {
        setUserDel(res.data);
        // console.log(res.data);
      });
  }, []);

  const handleTalks = async () => {
    let errorCount = 0;
    if (firstName === "" || !firstName) {
      errorCount++;
      setFirstNameErr("Please Enter Name");
    }
    if (mobile === "" || !mobile) {
      errorCount++;
      setMobileErr("Please Enter Number");
    }
    if (email === "" || !email) {
      errorCount++;
      setEmailErr("Please Enter Email");
    }
    if (message === "" || !message) {
      errorCount++;
      setMessageErr("Please Enter Message");
    }
    if (errorCount === 0) {
      // /email/sendEnquiry/{subject}/{message}/{to}/{from}

      const to = `noreply@${userDel.websitename}`;
      // const subject = "Welcome to Indian Bangles! ( " + email + ")";
      const subject = `Welcome to ${userDel.company}! ( ${email})`;
      const comment =
        message +
        " (Mobile no. " +
        mobile +
        ", Name: " +
        firstName +
        ", Email: " +
        email +
        ")";

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify({}),
      };

      fetch(
        headApi + `/email/sendEnquiry/${subject}/${comment}/${to}/${to}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Inserted Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully Sent!");
            setSubmitted(true);
          }
        });
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  return (
    <div className={classes.aboutUs} id="contactAreas">
      {submitted ? (
        <SweetAlert
          type={alertType}
          style={{ display: "block", marginTop: "100px" }}
          title={alertMsg}
          onConfirm={() => hideAlert()}
          confirmBtnCssClass={classeAlert.button + " " + classeAlert.success}
        >
          added to the Enquiry!!
        </SweetAlert>
      ) : null}
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classNames(classes.title, classes.textCenter)}>
            Tell us what you need, and we'll help you get quotes
          </h2>
          <h4 className={classNames(classes.description, classes.textCenter)}>
            All fields are mandatory
          </h4>
          <form>
            <GridContainer>
              <GridItem md={4} sm={4}>
                <CustomInput
                  labelText="Your name"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "firstName",
                    value: firstName,
                    // onChange: (e) => handleOtp(e),
                    onChange: (e) => {
                      setFirstName(e.target.value), setFirstNameErr("");
                    },
                    placeholder: "Enter Name here",
                    type: "text",
                    autoComplete: "off",
                  }}
                />
                <span style={{ color: "red" }}>{firstNameErr}</span>
              </GridItem>
              <GridItem md={4} sm={4}>
                <PhoneInput
                  // style={mystyle}
                  inputStyle={{
                    width: "100%",
                    border: "none",
                    borderBottom: "1px solid #040000 ",
                    borderRadius: "0",
                  }}
                  country={"in"}
                  name="mobile"
                  value={mobile}
                  // onChange={(mobile) => handleMobileNumber(mobile)}
                  onChange={(mobile) => {
                    setMobile(mobile.length <= 12 ? mobile : mobile);
                    setMobileErr("");
                  }}
                />
                <span style={{ color: "red" }}>{mobileErr}</span>
              </GridItem>
              <GridItem md={4} sm={4}>
                <CustomInput
                  labelText="Email"
                  id="email"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "email",
                    value: email,
                    // onChange: (e) => handleOtp(e),
                    onChange: (e) => {
                      setEmail(e.target.value), setEmailErr("");
                    },
                    placeholder: "Enter Email here",
                    type: "text",
                    autoComplete: "off",
                  }}
                  required={true}
                />
                <span style={{ color: "red" }}>{emailErr}</span>
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText="Message"
                  id="message"
                  number
                  inputProps={{
                    placeholder:
                      "Mix different four sizes in one design, or mix different six designs in one size.",
                    value: message,
                    multiline: true,
                    rows: 2,
                    onChange: (e) => {
                      setMessage(e.target.value), setMessageErr("");
                    },
                  }}
                  formControlProps={{
                    fullWidth: true,
                  }}
                />
                <span style={{ color: "red" }}>{messageErr}</span>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem
                md={4}
                sm={4}
                className={classNames(
                  classes.mrAuto,
                  classes.mlAuto,
                  classes.textCenter
                )}
              >
                <Button color="primary" round onClick={handleTalks}>
                  Let{"'"}s talk
                </Button>
              </GridItem>
            </GridContainer>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}
